var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvite16 = function SvgInvite16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.378 9.217A3.982 3.982 0 0 1 8 10a3.982 3.982 0 0 1-2.422-.816 4 4 0 1 1 4.8.033Zm-.088 2.33A5.98 5.98 0 0 1 8 12a5.98 5.98 0 0 1-2.29-.452l-.404 2.023 2.183-.646a1.799 1.799 0 0 1 1.021 0l2.184.646-.404-2.023Zm-6.387-1.163a6 6 0 1 1 8.193 0l.755 3.77a1.4 1.4 0 0 1-1.77 1.617L8 14.86l-3.08.91a1.4 1.4 0 0 1-1.77-1.616l.753-3.77Z",
    clipRule: "evenodd"
  })));
};
export default SvgInvite16;